import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { CanMatchFn, Router, RouterModule } from '@angular/router';
import { RegistrationStepQuery, RegistrationStepService, StepType } from '@fgb/core';

// Guard to check if friendKey is absent, if absent allow access to the component so user can enter it manually
export const friendKeyMatchGuard: CanMatchFn = () => {
  const registrationStepQuery = inject(RegistrationStepQuery);
  return registrationStepQuery.getQueryData('friendkey') === undefined;
};

@Component({
  selector: 'fgbcl-registration-refer-a-friend-with-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, FGBSharedModule, RouterModule],
  templateUrl: './registration-refer-a-friend-with-form.component.html',
  styleUrl: './registration-refer-a-friend-with-form.component.scss',
})
export class RegistrationReferAFriendWithFormComponent {
  readonly stepType = StepType.ReferAFriend;
  referralCodeForm: FormGroup;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private registrationService: RegistrationStepService
  ) {}

  ngOnInit(): void {
    this.referralCodeForm = this.formBuilder.group({
      friendKey: new FormControl('', [Validators.required]),
    });
  }

  submit() {
    this.referralCodeForm.markAllAsTouched();

    if (this.referralCodeForm.valid) {
      const { friendKey } = this.referralCodeForm.value;
      this.router.navigate(['/register/referafriend'], { queryParams: { friendkey: friendKey.trim() } });
    }
  }

  backToLogin(): void {
    this.registrationService.clearQueryData();
    this.router.navigate(['/login']);
  }
}
